import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';

import { OptionSwitch, getCheckedValue } from '@Pages/RetroSynthesis/ProjectParametersDialog/ProjectParametersHelpers';
import { getPredictedProcessingTimeIntervalUpdatedValue } from '@Pages/RetroSynthesis/utils';
import { isRPSChecked as isRPSCheckedFn } from '@Pages/RetroSynthesis/ProjectParametersDialog/RPS/mapRCSToRPS';
import { PREDICTED_IKTOS_PROCESSING_TIME_INTERVALS, ProjectSynthesisPartner } from '../constants';
import { RCS10D, RCSANY } from './constants';

const USED_BUILDING_BLOCKS = 'RX2_PREDICTION_PLAN_LIBRARIES';
const IKTOS_LENGTH_OF_ROUTES = 'RX2_PREDICTION_PLAN_IKTOS_MAXSTEPS';
const IKTOS_SELECTIVITY = 'RX2_PREDICTION_PLAN_IKTOS_REGIO';
const IKTOS_STEREO = 'RX2_PREDICTION_PLAN_IKTOS_STEREO';
const IKTOS_MAX_PRICE_PER_GRAM = 'RX2_PREDICTION_PLAN_IKTOS_PRICE';
const IKTOS_PROCESSING_TIME = 'RX2_PREDICTION_PLAN_IKTOS_PROCESSING_TIME';

const extractSelectedBuildingBlocks = (optionName, resp = []) => {
  const optionSet = find(resp, (item) => item && item.name === optionName) || {};
  const values =
    (optionSet.preferences &&
      optionSet.preferences.filter((element) => {
        if (!element.values) {
          return false;
        }
        const activeValue =
          element.values.length === 1
            ? element.values[0]
            : element.values.find((value) => (!isUndefined(value.checked) ? value.checked : value.defaultValue));
        return activeValue && activeValue.value === OptionSwitch.ON;
      })) ||
    [];
  return values.map((element) => element.name) || [];
};

export const extractCheifActiveValues = (optionName, resp = []) => {
  const optionSet = find(resp, (item) => item && item.name === optionName) || {};
  if (optionSet.values === undefined) return undefined;
  const activeValue =
    optionSet.values.length === 1
      ? optionSet.values[0]
      : optionSet.values.find((value) => (!isUndefined(value.checked) ? value.checked : value.defaultValue));
  return activeValue && activeValue.value;
};

export const extractDefaultPredictedParametersIktos = (optionResponse) => {
  if (!optionResponse) {
    return undefined;
  }
  const extractedUsedBuildingBlocks = extractSelectedBuildingBlocks(USED_BUILDING_BLOCKS, optionResponse) || [];
  const extractedMaxPricePerGram = extractCheifActiveValues(IKTOS_MAX_PRICE_PER_GRAM, optionResponse);
  const extractedStereo = extractCheifActiveValues(IKTOS_STEREO, optionResponse);

  return {
    maxNoOfSteps: extractCheifActiveValues(IKTOS_LENGTH_OF_ROUTES, optionResponse) || '15',
    firstDisconnect: extractCheifActiveValues(IKTOS_LENGTH_OF_ROUTES, optionResponse) === '1',
    selectivity: `${extractCheifActiveValues(IKTOS_SELECTIVITY, optionResponse)}` === OptionSwitch.ON,
    poolChiral: extractedStereo === undefined ? true : `${extractedStereo}` === OptionSwitch.OFF,
    maxPricePerGram: extractedMaxPricePerGram && `${extractedMaxPricePerGram}` !== '0' ? extractedMaxPricePerGram : '',
    usedBuildingBlocks: extractedUsedBuildingBlocks,
    isRPSChecked: isRPSCheckedFn(extractedUsedBuildingBlocks),
    isRCSUnchecked: !(extractedUsedBuildingBlocks.indexOf(RCS10D) >= 0 || extractedUsedBuildingBlocks.indexOf(RCSANY) >= 0),
    includeSubstructures: [],
    excludeSubstructures: [],
    processingTime: getPredictedProcessingTimeIntervalUpdatedValue(
      parseInt(getCheckedValue(IKTOS_PROCESSING_TIME, optionResponse), 10),
      PREDICTED_IKTOS_PROCESSING_TIME_INTERVALS
    ),
    partner: ProjectSynthesisPartner.IKTOS,
  };
};
